import { render } from "./AppSidenav.vue?vue&type=template&id=2e0e92b4"
import script from "./AppSidenav.vue?vue&type=script&lang=js"
export * from "./AppSidenav.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__